const includedElement = {
  id: '',
  description: '',
  fileInfo: '',
  label: '',
  value: ''
};

export default includedElement;
